/* ReviewSign — Success stories carousel + YouTube modal. */
(function () {
  'use strict';
  if (window.__rsxStories) return;
  window.__rsxStories = true;

  /* ---------- YouTube modal ---------- */
  function ensureModal() {
    var modal = document.getElementById('rsx-shared-modal');
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'rsx-shared-modal';
    modal.className = 'rsx rsx-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<div class="rsx-modal-inner">' +
      '<button type="button" class="rsx-modal-close" aria-label="Close">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.4"><path d="M18 6L6 18M6 6l12 12"/></svg></button>' +
      '<div class="rsx-modal-video" data-video></div></div>';
    document.body.appendChild(modal);
    var video = modal.querySelector('[data-video]');
    function close() { modal.classList.remove('open'); video.innerHTML = ''; document.body.style.overflow = ''; }
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    modal.querySelector('.rsx-modal-close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    modal.__open = function (id) {
      if (!id) return;
      video.innerHTML = '<iframe src="https://www.youtube.com/embed/' + encodeURIComponent(id) +
        '?autoplay=1&rel=0" title="Success story" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
      modal.classList.add('open'); document.body.style.overflow = 'hidden';
    };
    return modal;
  }

  function bindStories() {
    document.querySelectorAll('[data-rsx-story]').forEach(function (card) {
      if (card.__rsxBound) return;
      card.__rsxBound = true;
      card.addEventListener('click', function () {
        var id = card.getAttribute('data-youtube');
        if (id) ensureModal().__open(id);
      });
    });
  }

  /* ---------- Carousel ---------- */
  var INTERVAL = 4500;

  function initCarousel(el) {
    var track    = el.querySelector('.rsx-carousel-track');
    var viewport = el.querySelector('.rsx-carousel-viewport');
    var prevBtn  = el.querySelector('.rsx-carousel-btn--prev');
    var nextBtn  = el.querySelector('.rsx-carousel-btn--next');
    var dotsEl   = el.querySelector('.rsx-carousel-dots');
    if (!track) return;

    var slides  = Array.from(track.children);
    var current = 0;
    var timer   = null;
    var perView = parseInt(el.getAttribute('data-rsx-perview'), 10) || 0;

    function getVisible() { return perView || (window.innerWidth >= 768 ? 3 : 1); }
    function getMax()     { return Math.max(0, slides.length - getVisible()); }
    function slideWidth() { return slides[0] ? slides[0].offsetWidth : 0; }

    function goTo(idx) {
      current = Math.max(0, Math.min(idx, getMax()));
      track.style.willChange = 'transform';
      track.style.transform = 'translateX(-' + (current * slideWidth()) + 'px)';
      updateDots();
      updateArrows();
      clearTimeout(track._wct);
      track._wct = setTimeout(function () { track.style.willChange = 'auto'; }, 500);
    }

    function next() { goTo(current >= getMax() ? 0 : current + 1); }
    function prev() { goTo(current <= 0 ? getMax() : current - 1); }

    function startAuto() { clearInterval(timer); timer = setInterval(next, INTERVAL); }
    function stopAuto()  { clearInterval(timer); }
    function resetAuto() { stopAuto(); startAuto(); }

    function updateArrows() {
      var hide = getMax() === 0;
      if (prevBtn) prevBtn.style.visibility = hide ? 'hidden' : '';
      if (nextBtn) nextBtn.style.visibility = hide ? 'hidden' : '';
    }

    function buildDots() {
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      var count = getMax() + 1;
      if (count <= 1) return;
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'rsx-carousel-dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (idx) {
          dot.addEventListener('click', function () { goTo(idx); resetAuto(); });
        })(i);
        dotsEl.appendChild(dot);
      }
    }

    function updateDots() {
      if (!dotsEl) return;
      Array.from(dotsEl.children).forEach(function (d, i) {
        d.classList.toggle('active', i === current);
      });
    }

    prevBtn && prevBtn.addEventListener('click', function () { prev(); resetAuto(); });
    nextBtn && nextBtn.addEventListener('click', function () { next(); resetAuto(); });

    el.addEventListener('mouseenter', stopAuto);
    el.addEventListener('mouseleave', startAuto);

    /* touch swipe */
    var touchX = 0;
    track.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; stopAuto(); }, { passive: true });
    track.addEventListener('touchend',   function (e) {
      var dx = touchX - e.changedTouches[0].clientX;
      if (Math.abs(dx) > 40) { dx > 0 ? next() : prev(); }
      startAuto();
    }, { passive: true });

    /* rebuild on breakpoint change */
    var lastVis = getVisible();
    window.addEventListener('resize', function () {
      var v = getVisible();
      if (v !== lastVis) { lastVis = v; buildDots(); goTo(0); }
      else { goTo(current); } /* recalc px offset after resize */
    });

    el.__rsx = {
      relayout: function () { buildDots(); goTo(current); },
      start: startAuto,
      stop: stopAuto
    };

    buildDots();
    goTo(0);
    startAuto();
  }

  /* ---------- Industry tabs ---------- */
  function initTabs() {
    document.querySelectorAll('[data-rsx-tabs]').forEach(function (root) {
      if (root.__rsxTabs) return;
      root.__rsxTabs = true;
      var tabs   = Array.from(root.querySelectorAll('[data-rsx-tab]'));
      var panels = Array.from(root.querySelectorAll('[data-rsx-panel]'));
      if (!tabs.length) return;

      function activate(i) {
        tabs.forEach(function (t) {
          var on = +t.getAttribute('data-rsx-tab') === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = +p.getAttribute('data-rsx-panel') === i;
          p.hidden = !on;
          var car = p.querySelector('[data-rsx-carousel]');
          if (car && car.__rsx) {
            if (on) { car.__rsx.relayout(); car.__rsx.start(); }
            else { car.__rsx.stop(); }
          }
        });
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () { activate(+t.getAttribute('data-rsx-tab')); });
      });
      activate(0);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-rsx-carousel]').forEach(function (el) {
      if (!el.__rsxCarousel) { el.__rsxCarousel = true; initCarousel(el); }
    });
    bindStories();
    initTabs();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-rsx-carousel]').forEach(function (el) {
      el.__rsxCarousel = false;
    });
    initAll();
  });
})();
